import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';
import { useGetAllRiskScoringConfig } from '@views/RiskScore/hooks';
import { RiskScoreProvider } from '@views/RiskScore/RiskScoreContext';

const RISK_SCORE_PROJECTION_NAME = 'uber_assets';

const RiskScoreLayout = () => {
  const { data } = useGetAllRiskScoringConfig();

  if (!data) {
    return null;
  }

  return (
    <RiskScoreProvider data={data} riskScoreProjectionName={RISK_SCORE_PROJECTION_NAME}>
      <Outlet />
    </RiskScoreProvider>
  );
};

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score')({
  beforeLoad: () => getTitleContextSlice('Risk Score'),
  staticData: {
    owner: CodeOwner.Uvm,
  },
  component: RiskScoreLayout,
});
